import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { stringFormat, toParse } from '@ugc-utils/utils';
import { VisibilityOff, Chat } from '../../../icons';

@Component({
  tag: 'ugc-review-learn-more-modal',
  shadow: false,
})
export class UgcReviewLearnMoreModal {
  render() {
    const {
      isShowReviewLearnMoreModal,
      reviewStaticLanguage: {
        IDS_UGC_WRITE_A_REVIEW_GUIDELINES_TITLE = '',
        IDS_UGCI_START_REVIEWING = '',
        IDS_UGC_WRITE_REVIEW_GUIDELINES = '',
      } = {},
      isDesktop,
    } = state;

    const contents = toParse(IDS_UGC_WRITE_REVIEW_GUIDELINES);

    const {
      charitableCause = { header: '', subheader: '' },
      guidelines = { content: [], title: '' },
      rewards = { content: [], title: '' },
    } = contents;

    const catalogUrl = state.domains.catalog || '';

    const customerServicePageUrl = `${catalogUrl}/help/contact`;

    const donatePageUrl = `${catalogUrl}/info/donate`;

    const guideLineItems = [
      {
        id: 1,
        icon: <VisibilityOff />,
        text: <p class="mx-8">{guidelines.content[1]}</p>,
      },
      {
        id: 2,
        icon: <VisibilityOff />,
        text: <p class="mx-8">{guidelines.content[2]}</p>,
      },
      {
        id: 3,
        icon: <Chat />,
        text: <p class="mx-8 hover-link" innerHTML={stringFormat(guidelines.content[3], customerServicePageUrl)} />,
      },
    ];
    const rewardsItems = [
      {
        id: 1,
        text: rewards.content[2],
      },
    ];
    const getLearnMoreItems = () => (
      <div>
        <h4 class="my-0 mb-8">{charitableCause.header}</h4>
        <li
          class="mb-8 fs-12 lh-20 hover-link"
          style={{ listStyle: 'none' }}
          innerHTML={stringFormat(charitableCause.subheader, '', donatePageUrl)}
        />

        <h4 class="my-0 mb-8">{guidelines.title}</h4>
        <ul class="m-0 p-0">
          {guideLineItems.map(({ id, icon, text }) => (
            <li class="flex-row-start-center mb-8 fs-12 lh-20" style={{ listStyle: 'none' }} key={id}>
              {icon}
              {text}
            </li>
          ))}
        </ul>
        <h4 class="my-0 mb-8">{rewards.title}</h4>
        <ul class="m-0 p-0">
          {rewardsItems.map(({ id, text }) => (
            <li class="flex-row-start-center mb-8 fs-12 lh-20" style={{ listStyle: 'none' }} key={id}>
              {text}
            </li>
          ))}
        </ul>
        <ugc-button height="48" onClick={() => (window.location.href = '/ugc/myaccount/review')}>
          {IDS_UGCI_START_REVIEWING}
        </ugc-button>
      </div>
    );

    return isDesktop ? (
      <ugc-modal-dialog
        width={480}
        isShow={isShowReviewLearnMoreModal}
        modalTitle={IDS_UGC_WRITE_A_REVIEW_GUIDELINES_TITLE}
        handleCancel={() => (state.isShowReviewLearnMoreModal = false)}
      >
        {isShowReviewLearnMoreModal && <div class="px-16 pb-16 fs-14 color-gray-700">{getLearnMoreItems()}</div>}
      </ugc-modal-dialog>
    ) : (
      <ugc-drawer
        isShow={isShowReviewLearnMoreModal}
        modalTitle={IDS_UGC_WRITE_A_REVIEW_GUIDELINES_TITLE}
        isShowButton={false}
        handleCancel={() => (state.isShowReviewLearnMoreModal = false)}
      >
        {isShowReviewLearnMoreModal && <div class="px-16 pb-16">{getLearnMoreItems()}</div>}
      </ugc-drawer>
    );
  }
}
